export const databaseInstances: Array<{ id: number; name: string }> = [
		{ id: 1, name: 'PIPS' },
		{ id: 2, name: 'AIM ECC' },
		{ id: 3, name: 'AIM RLA' },
		{ id: 4, name: 'AIM South & Western' },
		{ id: 5, name: 'AIM Texas Security General' },
	];